import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_2 = { class: "control-label col-sm-6" }
const _hoisted_3 = { class: "col-sm" }

import { inject} from 'vue';

export default {
  __name: 'RegimeFiscale',
  props: {
  validazione: {
    type: [Object],
    default: {}
  },
  helper: {
    type: [Object,String],
    default: {}
  },
  readonly:{
    type: Boolean,
    default:false
  }
},
  setup(__props) {

const { regimeFiscale, updateRegimeFiscale } = inject('regimeFiscale')
const props = __props;
if(props.validazione){
props.validazione.regime_fiscale.value = regimeFiscale.value;
}
function resetRitenuta(){
  if(props.validazione.ritenuta_acconto){
    props.validazione.ritenuta_acconto.value = 0;
  }
}
const dati_distretto = inject('datiDistretto');

return (_ctx, _cache) => {
  const _component_base_select = _resolveComponent("base-select")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.validazione.regime_fiscale.label), 1 /* TEXT */)
    ])), [
      [_directive_fallcohelper, __props.helper.calcolo.regime_fiscale.ref]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_base_select, {
        name: "regime_fiscale",
        options: [
        {name: 'Ordinario', value: 'ordinario'},
        {name: 'Forfettario', value: 'forfettario'}
        ],
        isSelected: __props.validazione.regime_fiscale.value !== '',
        state: __props.readonly === true ?'disable':'',
        onChange: _cache[0] || (_cache[0] = $event => (_unref(updateRegimeFiscale)($event),resetRitenuta())),
        validateTo: __props.validazione.regime_fiscale,
        "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((__props.validazione.regime_fiscale) = $event))
      }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
    ])
  ]))
}
}

}